/// *** System import ***///
import { Component, ViewChild } from '@angular/core';
import { Content, Events, PopoverController, ToastController } from 'ionic-angular';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
declare var Highcharts: any;
/// *** Custom import ***///
import { Globals } from '../../../../app/globals';
import { SessionProvider } from '../../../../providers/session';
import { Market_SessionInstrumentStore } from '../sessionInstrument.store';

@Component({
  selector: 'page-market-sessionInstrument-history',
  templateUrl: 'history.html'
})
export class Market_SessionInstrumentHistoryPage {
  @ViewChild(Content) private content: Content;
  private chart: any;
  constructor(
    // *** System
    private events: Events,
    private popoverCtrl: PopoverController,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    private session: SessionProvider,
    private store: Market_SessionInstrumentStore) {
  }

  // *** Evénement de chargement
  ngOnInit() {
    try {
      this._buildChart();
      this._eventsSub();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Evénement de clôture
  ionViewWillLeave() {
    try {
      this._eventsUnsub();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Construire le chart de l'intraday
  private _buildChart() {
    this.chart = new Highcharts.stockChart('historyContainer', {
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false
      },
      rangeSelector: {
        buttons: [{
          type: 'month',
          count: 1,
          text: '1m'
        }, {
          type: 'month',
          count: 3,
          text: '3m'
        }, {
          type: 'month',
          count: 6,
          text: '6m'
        }, {
          type: 'year',
          count: 1,
          text: '1a'
        }, {
          type: 'all',
          text: 'All'
        }],
        inputEnabled: false, // it supports only days
        selected: 3 // 1a
      },
      series: [{
        name: 'AAPL',
        tooltip: {
          valueDecimals: 2
        }
      }],
    });
    this.chart['series'][0].setData(this.store.activeSessionInstrument.history);
    this.content.resize();
  }

  // *** S'inscrire aux évènements
  private _eventsSub() {
    // On 'resetInstrumentInfos'
    this.events.subscribe('Market_SessionInstrumentStore.reset', eventData => {
      this.chart['series'][0].setData([]);
    });
  }

  // *** S'inscrire aux évènements
  private _eventsUnsub() {
    this.events.unsubscribe('Market_SessionInstrumentStore.reset');
  }
}


// WEBPACK FOOTER //
// ./src/pages/market/sessionInstrument/history/history.ts